import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { Button, Input } from 'semantic-ui-react';
import { Text, Row, Col, Separator } from '@cuemath/comps';

const LongInput = styled(Input)`
  width: 300px;
`;

const getInitialInput = (initialData, inputKeys) => {
  return initialData.map(data => {
    const responseMap = {};
    inputKeys.forEach(key => {
      responseMap[key] = data[key] || '';
    });
    return responseMap;
  });
};

export default class JsonInput extends PureComponent {
  static propTypes = {
    inputData: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
    onSubmit: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    inputKeys: PropTypes.array.isRequired,
  };

  constructor(props) {
    super();
    const { inputData, inputKeys } = props;

    this.state = {
      inputs: getInitialInput(inputData, inputKeys),
    };
  }

  handleChange = (index, key, value) => {
    const { inputs } = this.state;
    this.setState(
      {
        inputs: [
          ...inputs.slice(0, index),
          { ...inputs[index], [key]: value },
          ...inputs.slice(index + 1, inputs.length),
        ],
      },
      () => {
        this.handleSubmit();
      },
    );
  };

  onDeleteClick = index => {
    const { inputs } = this.state;
    this.setState(
      {
        inputs: [...inputs.slice(0, index), ...inputs.slice(index + 1, inputs.length)],
      },
      () => {
        this.handleSubmit();
      },
    );
  };

  renderInputs = () => {
    const { inputKeys } = this.props;
    const { inputs } = this.state;
    const inputComps = [];
    inputs.forEach((input, index) => {
      inputComps.push(
        <Row gap={4} key={index} alignItems="center">
          {inputKeys.map(inputKey => (
            <Col key={inputKey}>
              <LongInput
                name={inputKey}
                label={inputKey}
                value={input[inputKey]}
                onChange={(e, { name, value }) => {
                  this.handleChange(index, name, value);
                }}
              />
            </Col>
          ))}
          <Col>
            <Button
              size="mini"
              circular
              color="red"
              icon="close"
              onClick={() => {
                this.onDeleteClick(index);
              }}
            />
          </Col>
        </Row>,
      );
    });
    return inputComps;
  };

  onNewFieldAddClick = () => {
    const { inputKeys } = this.props;
    const { inputs } = this.state;
    const initialInput = {};
    inputKeys.forEach(inputKey => {
      initialInput[inputKey] = '';
    });
    this.setState({
      inputs: [...inputs, initialInput],
    });
  };

  handleSubmit = () => {
    const { onSubmit, inputKeys } = this.props;
    const { inputs } = this.state;
    const responseData = inputs.map(input => {
      const responseObj = {};
      inputKeys.forEach(inputKey => {
        responseObj[inputKey] = input[inputKey];
      });
      return responseObj;
    });
    onSubmit(responseData);
  };

  render() {
    const { label } = this.props;
    return (
      <>
        <Row alignItems="center">
          <Col>
            <Text>{label}</Text>
          </Col>
          <Col>
            <Button
              color="blue"
              icon="plus"
              content={'Add new'}
              onClick={this.onNewFieldAddClick}
            />
          </Col>
        </Row>
        <Separator transparent height="6" />
        {this.renderInputs()}
      </>
    );
  }
}
